require('./brokerWarrantsSellSuccess.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @helpers
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL,
    MYPROFILE_BROKER_URL,
    HYPHEN,
    TYPE_WARRANTS
} = require('constants/index');

const BrokerWarrantsSellSuccess = props => {
    const { productFile, immBrokerWarrantsSell, immStocksContracts } = props;
    const mockedOrderNumber = immBrokerWarrantsSell.getIn(['orderConfirmation','orderNumber'], HYPHEN);
    const successMessage = formatText('broker-warrantsSellSuccessStepMessage');
    const successSubMessage = formatText('broker-warrantsSellSuccessStepSubMessage', [
        mockedOrderNumber
    ]); //@hardcoded and mocked 'til we receive this from the reducer
    const mainButtonLabel = formatText('broker-warrantsSellSuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText(
        'broker-warrantsSellSuccessStepReviewOrdersButtonLabel'
    );
    const step1 = immBrokerWarrantsSell.get('steps').get(FIRST_STEP);
    const step2 = immBrokerWarrantsSell.get('steps').get(SECOND_STEP);
    const stocksContractSelectedValue = immBrokerWarrantsSell.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
    const stockContract = immStocksContracts.find(contract => {
        return contract.get('contactNumber') === stocksContractSelectedValue;
    });
    const productCurrency = productFile.get('currencyCode');

    return (
        <WizardSuccess
            successMessage={successMessage}
            successSubMessage={successSubMessage}
            customClassName="warrants-sell-success"
            mainButton={{label: mainButtonLabel, url: MYPROFILE_BROKER_URL}}
            secondaryButton={{label: secondaryButtonLabel, url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL}}
        >
            <div>
                <h2 className="warrants-sell-success__summary-header">
                    <FormattedText value="broker-warrantsSellSuccessStepSubtitle" />
                </h2>
                <StocksBuySellSummary
                    productName={formatText('broker-warrantProductName')}
                    productCurrency={productCurrency}
                    stockContract={stockContract}
                    stockDescription={productFile.get('companyName')}
                    step1={step1}
                    step2={step2}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                    maskLimitOrderType={true}
                    productType={TYPE_WARRANTS}
                />
            </div>
        </WizardSuccess>
    );
};

BrokerWarrantsSellSuccess.propTypes = {
    productFile: PropTypes.object.isRequired,
    immBrokerWarrantsSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
};

module.exports = BrokerWarrantsSellSuccess;
